// File: src/data/introConfigs.js
// -----------------------------------------------------------------------------
// Configurations des écrans d'introduction pour chaque questionnaire
// -----------------------------------------------------------------------------
import React from 'react';

// Icône boussole pour le questionnaire valeurs
const CompassIcon = () => (
  <span className="values-intro-icon">💜</span>
);

// Icône hexagone RIASEC
const RiasecIcon = () => (
  <span className="values-intro-icon">🧭</span>  
);

export const valeursIntroConfig = {
  icon: <CompassIcon />,
  title: (prenom) => `${prenom}, découvre ce qui\nguide tes choix`,
  description: "Réponds spontanément,\nil n'y a pas de mauvaise réponse.",
  reassurances: [
    "Pas de bonne ou mauvaise réponse",
    "Réponds selon ce que tu ressens"
  ],
  duration: "⏱ 5 min · 30 questions"
};

export const riasecIntroConfig = {
  icon: <RiasecIcon />,
  title: (prenom) => `${prenom}, découvre ce que\ntu aimes faire`,
  description: "Réponds spontanément,\nil n'y a pas de mauvaise réponse.",
  reassurances: [
    "Pas de bonne ou mauvaise réponse",
    "Choisis selon tes envies, pas selon ce qu'on attend de toi"
  ],
  duration: "⏱ 5 min · 30 activités"
};

// Icône pour le questionnaire Jourda
const JourdaIcon = () => (
  <span className="intro-icon jourda-intro-icon">⚡</span>
);

export const jourdaIntroConfig = {
  icon: <JourdaIcon />,
  title: (prenom) => `${prenom}, découvre ce qui\nte motive`,
  description: "Réponds spontanément,\nil n'y a pas de mauvaise réponse.",
  reassurances: [
    "Pas de bonne ou mauvaise réponse",
    "Fais confiance à ton instinct"
  ],
  duration: "⏱ 3 min · 14 questions"
};

// Icône pour le questionnaire Intelligences Multiples
const ImIcon = () => (
  <span className="intro-icon im-intro-icon">🧩</span>
);

export const imIntroConfig = {
  icon: <ImIcon />,
  title: (prenom) => `${prenom}, découvre en quoi\ntu excelles`,
  description: "Réponds spontanément,\nil n'y a pas de mauvaise réponse.",
  reassurances: [
    "Pas de bonne ou mauvaise réponse",
    "Chaque intelligence est une force"
  ],
  duration: "⏱ 5 min · 32 questions"
};